
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'

@Component
export default class ClientsSideviewGeneralTab extends Vue {
 @Prop() client: Record<string, any>;


  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

};
